import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=5e27fd2a&scoped=true&"
var script = {}
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=5e27fd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27fd2a",
  null
  
)

export default component.exports